<script>
import Card from '../../../Components/Card.vue';
import { formatDateTime } from '../../../Modules/Dates.js';
import moment from 'moment-timezone';

export default {
  components: { Card },

  props: {
    masterConfig: Object,
    kioskKey: String,
    form: Object,
    kiosk: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      confirmation: new URL('/resources/img/confirmation.svg', import.meta.url).href,
      countdown: 5,
    };
  },

  mounted() {
    if (this.form.appointment === null) {
      this.countdownTimerAndRefresh();
    }

    if (this.kiosk) {
      this.countdownTimerAndRefresh();
    }
  },

  computed: {
    appointmentTime() {
      if (this.form.appointment === undefined || this.form.appointment === null) {
        return '--';
      }
      const dateStr = this.form.appointment.slice(0, 19); // "2025-09-05T09:00:00"
      const date = new Date(dateStr);

      const dateFormatted = date.toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
      const timeFormatted = date.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      });

      return `${dateFormatted} @ ${timeFormatted}`;
    },
  },

  methods: {
    formatDateTime,

    countdownTimerAndRefresh() {
      let vm = this;
      if (this.countdown > 0) {
        setTimeout(function () {
          vm.countdown--;
          vm.countdownTimerAndRefresh();
        }, 1100);
        return;
      }

      window.location.reload();
    },

    addToGoogleCalendar() {
      let startDate = new Date(this.form.appointment.slice(0, 19));
      let endDate = new Date(startDate.getTime() + 60 * 60 * 1000);

      console.log('startDate:', startDate, typeof startDate);
      console.log('endDate:', endDate, typeof endDate);

      const event = {
        title: 'Appointment With ' + this.masterConfig.shop_name,
        details: 'Appointment with ' + this.masterConfig.shop_name,
        location: this.masterConfig.address,
        start: startDate,
        end: endDate,
      };

      const googleUrl = new URL('https://calendar.google.com/calendar/render');
      googleUrl.searchParams.set('action', 'TEMPLATE');
      googleUrl.searchParams.set('text', event.title);
      googleUrl.searchParams.set('details', event.details);
      googleUrl.searchParams.set('location', event.location);
      googleUrl.searchParams.set(
        'dates',
        `${this.formatDateToGoogle(startDate)}/${this.formatDateToGoogle(endDate)}`,
      );

      return googleUrl.toString();
    },

    formatDateToGoogle(date) {
      console.log('formatDateToGoogle received:', date, typeof date);

      // Add type checking
      if (!(date instanceof Date)) {
        console.error('Expected Date object, got:', typeof date);
        return '';
      }

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}${month}${day}T${hours}${minutes}${seconds}`;
    },
  },
};
</script>

<template>
  <Card class="text-center mt-3">
    <img :src="confirmation" alt="Handshake" class="confirmation-image" />

    <template v-if="kiosk || this.form.appointment === null">
      <h4 class="mb-4">You are now checked in</h4>

      <h3>This page will refresh in {{ countdown }} seconds</h3>
    </template>

    <template v-else>
      <h5 class="mb-2 appointment-set-title">
        <template v-if="form.appointment === null"> Checkin Complete! </template>
        <template v-else>
          <span class="appointment-set-content">
            <i class="fa-regular fa-circle-check" />
            <span>Appointment set!</span>
          </span>
        </template>
      </h5>
      <p v-if="form.appointment !== null" class="appointment-time">
        {{ appointmentTime }}
      </p>
      <a
        v-if="form?.appointment !== null"
        :href="addToGoogleCalendar()"
        target="_blank"
        class="add-to-calendar"
        >Add to Calendar <span>+</span></a
      >
    </template>
  </Card>
</template>

<style scoped>
.confirmation-image {
  max-width: 400px;
  margin-bottom: 30px;
  margin-top: 30px;
}
.add-to-calendar {
  color: #007bff;
  cursor: pointer;
  font-weight: 500;
  margin-top: 10px;
  display: inline-block;
}

.appointment-set-title {
  font-size: 1.65rem;
  font-weight: 700;
}

.appointment-set-content {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  color: #198754;
}

.appointment-set-content i {
  font-size: 1.6rem;
  font-weight: 700;
  color: #198754;
}

.appointment-time {
  font-size: 1.25rem;
  font-weight: 500;
}
</style>
